import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import HowToJoinPage from 'src/app/Signup/HowToJoinPage'
import SignupFullPage from 'src/app/Signup/SignupFullPage'
import SignupHalfPage from 'src/app/Signup/SignupHalfPage'
import MobileWebPopup from 'src/components/MobileWebPopup/MobileWebPopup'
import { SupportedBrands } from 'src/enums'
import SignupCMS from 'src/feature/MarketingCMS/SignupCMS'
import { selectIsMobileWebPopupOpenFromState } from 'src/redux/selectors/app.selectors'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { selectQueryParams } from 'src/redux/selectors/router.selectors'
import {
  selectAppName,
  selectBrandName,
} from 'src/redux/selectors/session.selectors'

import style, { mobilePopupStyle } from './SignupPage.style'

const SignupPage: React.FC = () => {
  const brand = useSelector(selectBrandName)
  const showMarketingCMS = useSelector(
    selectFeatureFlaggerFromState,
  )?.show_marketing_cms

  const appName = useSelector(selectAppName)
  const queryParams = useSelector(selectQueryParams)
  const isMobileWebPopupOpen = useSelector(selectIsMobileWebPopupOpenFromState)

  const { orgName, inviteeEmail, inviterName, inviterEmail } = queryParams

  const signupAndJoin = !!(
    orgName &&
    inviteeEmail &&
    inviterName &&
    inviterEmail
  )

  const [showHowToJoin, setShowHowToJoin] = useState<boolean>(false)

  let content
  if (showHowToJoin) {
    content = <HowToJoinPage setShowHowToJoin={setShowHowToJoin} />
  } else if (showMarketingCMS && brand === SupportedBrands.Extend) {
    content = (
      <div css={style}>
        <SignupCMS />
        <SignupHalfPage setShowHowToJoin={setShowHowToJoin} />
      </div>
    )
  } else {
    content = <SignupFullPage setShowHowToJoin={setShowHowToJoin} />
  }

  return (
    <>
      <Helmet>
        <title>{`Get started today and create virtual cards with the card in your pocket. | ${appName}`}</title>
        <meta
          name="description"
          content={`Create an ${appName} account to create, send, and manage virtual cards for all your business payments.`}
        />
      </Helmet>
      {isMobileWebPopupOpen && (
        <div css={mobilePopupStyle}>
          <MobileWebPopup signupAndJoin={signupAndJoin} />
        </div>
      )}
      {content}
    </>
  )
}

export default SignupPage
